module.exports = __webpack_public_path__ + "static/media/2.9260cb71.png";